module.exports = __webpack_public_path__ + "media/assets/images/cancel-e53aade261ab4c2e043c037db12478b5.svg";